import { Box } from '@mui/material';
import React, { useState } from 'react';
import '../../types';
import { WidgetTable_Cell, WidgetTable_Row } from 'emerald-ui';
import { TravelHistory_Count, TravelHistory_Icon } from './TravelHistory.style';
import { isMidnightDateTime } from '../../utilities/dates';
import { faChevronDown, faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const TravelHistoryRow = (props) => {
    const [rowExpanded, setRowExpanded] = useState(false);
    const { dataRow } = props;
    const dateTime = new Date(dataRow.timestamp);
    const options = Intl.DateTimeFormatOptions = { month: '2-digit', day: '2-digit', year: 'numeric' };
    let time = '';

    const handleRowClick = () => {
        setRowExpanded(!rowExpanded);
    };

    if (isMidnightDateTime(dataRow.timestamp)) {
        options.timeZone = 'UTC';
    } else {
        //Only convert time if it isn't midnight.
        time = dateTime.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
    }

    const date = dateTime.toLocaleDateString('en-US', options);
    const additionalEntryCount = dataRow.additionalEntries.length;
    const chevronDown = <FontAwesomeIcon icon={faChevronDown} size='xs' />;
    const chevronRight = <FontAwesomeIcon icon={faChevronRight} size='xs' />;
    const leftContent = additionalEntryCount > 0 ? rowExpanded ? chevronDown : chevronRight : null;

    return (
        <>
            <WidgetTable_Row onClick={handleRowClick} style={{ cursor: additionalEntryCount > 0 ? 'pointer' : 'default' }}>
                <WidgetTable_Cell>
                    <Box sx={{ width:'16px' }}>
                        {leftContent}
                    </Box>
                    <TravelHistory_Icon src={dataRow.icon} />
                    {additionalEntryCount > 0 && (
                        <TravelHistory_Count>
                            {additionalEntryCount}
                        </TravelHistory_Count>

                    )}
                    {dataRow.status}
                </WidgetTable_Cell>
                <WidgetTable_Cell>{dataRow.location}</WidgetTable_Cell>
                <WidgetTable_Cell alignRight>
                    {date}
                    {time != '' && (
                        <Box
                            sx={{ display: { xs: 'none', sm:'block' } }}
                        >
                        &nbsp;{time}
                        </Box>
                    )}
                </WidgetTable_Cell>
            </WidgetTable_Row>

            {rowExpanded && (
                dataRow.additionalEntries.map((additionalEntry) => {
                    const additionalEntryDateTime = new Date(additionalEntry.timestamp);
                    const additionalEntryOptions = Intl.DateTimeFormatOptions = { month: '2-digit', day: '2-digit', year: 'numeric' };
                    let additionalEntryTime = '';

                    if (isMidnightDateTime(additionalEntry.timestamp)) {
                        additionalEntryOptions.timeZone = 'UTC';
                    } else {
                        //Only convert time if it isn't midnight.
                        additionalEntryTime = additionalEntryDateTime.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
                    }

                    const additionalEntryDate = additionalEntryDateTime.toLocaleDateString('en-US', options);

                    return (
                        <WidgetTable_Row key={additionalEntry.timestamp}>
                            <WidgetTable_Cell>
                                <Box sx={{ width:'30px' }} />
                                <TravelHistory_Icon src={additionalEntry.icon} />
                                {additionalEntry.status}
                            </WidgetTable_Cell>
                            <WidgetTable_Cell>{additionalEntry.location}</WidgetTable_Cell>
                            <WidgetTable_Cell alignRight>
                                {additionalEntryDate}
                                {additionalEntryTime != '' && (
                                    <Box
                                        sx={{ display: { xs: 'none', sm:'block' } }}
                                    >
                                        &nbsp;{additionalEntryTime}
                                    </Box>
                                )}
                            </WidgetTable_Cell>
                        </WidgetTable_Row>
                    );
                })
            )}
        </>
    );
};
